import * as React from 'react';
import { Text, Bold } from '@serodigital/ui-components';

interface IProps {
  label: string;
  value: string | number | boolean | JSX.Element;
}

export function DataLabel({ label, value }: IProps) {
  if (!value) return null;

  return (
    <div data-qa={`data-label-${label}`} className="flex flex-col">
      <div className="pb-12">
        <Text>{label}:</Text>
      </div>
      {['number', 'string', 'boolean'].includes(typeof value) ? <Bold>{value}</Bold> : value}
    </div>
  );
}
